<template>
  <div class="pb-3" >
    <va-card :title="$t(`products.cards.${titleCard}`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(upload)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Nome do Produto" v-slot="{ errors }">
                <va-input
                  v-model="product.name"
                  class="mt-2"
                  :label="$t('products.forms.nameLabel')"
                  :placeholder="$t('products.forms.namePlaceholder')"
                  :success="errors.length == 0 && product.name.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Descrição do Produto" v-slot="{ errors }">
                <p>{{$t('products.forms.descriptionLabel')}}</p>
                <ckeditor :editor="editor" id='editor' v-model="product.description" :config="editorConfig"></ckeditor>
                <ErrorMessages :errors='errors'/>
              </ValidationProvider>
              <div v-if='oldImage.length > 0' class="form-group mt-3">
                <img
                  :src="$store.getters['environment/cdn'] + '/products/' + oldImage"
                  style="height: 30vh; max-width: 100%;"
                >
              </div>
              <ValidationProvider name="Imagem" :rules="oldImage.length > 0 ? '' : 'required'" v-slot="{ errors }">
                <div class="form-group mt-3">
                  <label
                    class="va-input__container__label position"
                    style="color: rgb(108, 127, 238);">
                    {{$t('products.forms.imageLabel')}}
                  </label>
                  <va-file-upload
                    type="single"
                    v-model="image"
                  />
                  <ErrorMessages :errors='errors'/>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" name="Valor do Produto" v-slot="{ errors }">
                <va-input
                  v-model="value"
                  :label="$t('products.forms.valueLabel')"
                  :placeholder="$t('products.forms.valuePlaceholder')"
                  :success="errors.length == 0 && value > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import ErrorMessages from '../utils/ErrorMessages'
import Editor from 'ckeditor5-custom-build/build/ckeditor.js'
import '../posts/ckeditor.css'
import gql from 'graphql-tag'
export default {
  name: 'ProductsAddUpdate',
  components: { ErrorMessages },
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateData: {
      required: true,
    },
  },
  data () {
    return {
      product: {
        name: '',
        description: '',
        image: '',
        value: '',
      },
      oldImage: '',
      image: [],
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
      editor: Editor,
      editorConfig: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            'link',
            'bulletedList',
            'numberedList',
            '|',
            'outdent',
            'indent',
            '|',
            'imageUpload',
            'blockQuote',
            'htmlEmbed',
            'insertTable',
            'mediaEmbed',
            'undo',
            'redo',
          ],
        },
        language: 'pt-br',
        image: {
          toolbar: [
            'imageTextAlternative',
            'toggleImageCaption',
            'imageStyle:inline',
            'imageStyle:block',
            'imageStyle:side',
          ],
        },
        table: {
          contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells',
          ],
        },
      },
    }
  },
  created () {
    this.product.name = ''
    this.product.description = ''
    this.product.image = ''
    this.product.value = 0
    if (this.updateData !== null) {
      this.product_get(this.updateData)
    }
  },
  computed: {
    value: {
      get () {
        return this.product.value
      },
      set (value) {
        if (value > 0) {
          this.product.value = value
        }
      },
    },
  },
  watch: {
    image (value) {
      if (value.length > 0) {
        this.product.image = value[0].name
      }
    },
    updateData (value) {
      if (this.updateData !== null) {
        this.product_get(this.updateData)
      } else {
        this.product.name = ''
        this.product.description = ''
        this.product.image = ''
        this.product.value = 0
      }
    },
  },
  methods: {
    cancel () {
      this.$emit('showAdd', false)
    },
    product_get (data) {
      Object.keys(data).forEach((value, key) => {
        if (value === 'image') {
          this.oldImage = data[value]
          this.product[value] = ''
        } else if (value !== '__typename') {
          this.product[value] = data[value]
        }
      })
    },
    upload () {
      if (this.product.image.length !== 0) {
        const formData = new FormData()
        formData.append('file', this.image[0])
        formData.append('path', 'products')
        if (this.updateData !== null) {
          formData.append('deleteFile', this.oldImage)
        }
        this.$axios.post(
          '/api/upload',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        ).then(resp => {
          this.product.image = resp.data.filename
          this.onSubmit()
        })
      } else {
        this.product.image = this.oldImage
        this.onSubmit()
      }
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const { name, description, image, value } = this.product
      const self = this
      this.$apollo
        .mutate({
          mutation: (
            this.updateData !== null ? gql`
                mutation MyMutation($name: String, $description: String, $image: String, $value: Int, $id: Int!) {
                  update_product_by_pk(pk_columns: {id: $id}, _set: {name: $name, description: $description, image: $image, value: $value}) {
                    id
                  }
                }
                ` : gql`
                mutation MyMutation($name: String, $description: String, $image: String, $value: Int) {
                  insert_product(objects: {name: $name, description: $description, image: $image, value: $value}) {
                    affected_rows
                  }
                }
                `),
          variables: this.updateData !== null ? {
            name,
            description,
            image,
            value,
            id: this.product.id,
          } : {
            name,
            description,
            image,
            value,
          }
          ,
        })
        .then(data => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.product.name = ''
          self.product.description = ''
          self.product.image = ''
          self.product.value = 0
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.successUpdate' : 'toasts.successCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.product.name = ''
          self.product.description = ''
          self.product.image = ''
          self.product.value = 0
          self.$emit('showAdd', false)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.errorUpdate' : 'toasts.errorCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
.va-message-list {
  &__message {
    vertical-align: middle;
    font-size: $font-size-mini;
    color: rgb(248, 112, 109);
  }
}

.position {
  position: relative;
}
</style>
